import { ConfigType, initConfig } from '@affiliate-frontend-analytics/events'

import { getBrandConfig } from '../../brands'
import { SYSTEM_EVENTS_NAMES } from '../constants'
import { analyticsClientErrorCallback } from './analyticsClientErrorCallback'
import { appVersion } from './appVersion'
import { FGP_TOKEN } from './fingerprintToken'

const {
  brandConfig: { brandId, brandName },
} = getBrandConfig()

const baseConfig: ConfigType = {
  apiKey: FGP_TOKEN,
  appVersion: `${brandName}/version-${appVersion}`,
  brandId,
  errorCallback: analyticsClientErrorCallback,
  systemEventsNames: SYSTEM_EVENTS_NAMES,
}

export const createEventConfig = (additionalConfig: ConfigType) => {
  initConfig({
    ...baseConfig,
    ...additionalConfig,
  })
}
